import { Controller } from "stimulus";
import { Accordion } from "accordion";

export default class extends Controller {
  // static get targets() {
  //   return [""];
  // }
  initialize() {
    // console.log("Accordion Div Controller working!");
  }
  connect() { 
    for(const el of document.querySelectorAll(".accordion"))
      new Accordion(el, {
        heightOffset: 34,
        onToggle: function(fold, isOpen){
          const caret = fold.el.children[0].children[1].children[0];
          if (!isOpen) {
            caret.style.transform = "rotate(0deg)";
            caret.style.transitionDuration = "0.2s";
          } else {
            caret.style.transform = "rotate(90deg)";
            caret.style.transitionDuration = "0.2s";
          }
          // if(stillLoading) return false;
        }
      });
    
    // console.log(this.triggerTarget);
    // console.log(this.contentTarget);
  }
  
}